import { action, get } from "@ember/object"
import type Transition from "@ember/routing/-private/transition"
import Route from "@ember/routing/route"
import { scheduleOnce } from "@ember/runloop"
import { inject as service } from "@ember/service"
import type { User } from "@shared/models/user"
import type EmberStore from "cc-frontend/services/ember-store"
import { isNil } from "lodash"
import { Promise } from "rsvp"

export default class ShowRoute extends Route<User> {
  @service("ember-store") declare store: EmberStore

  model(params) {
    if (!isNil(params.redirectToPlanbookId)) {
      scheduleOnce("afterRender", this, () => {
        // We remove this otherwise we keep endlessly redirecting back to the planner.week
        // @ts-ignore
        this.replaceWith({ queryParams: { redirectToPlanbookId: null } })
        this.transitionTo("planbookv5.planner.week", params.redirectToPlanbookId)
      })
    }

    return new Promise<User>((resolve, reject) => {
      return get(this, "store")
        .find("user", params.user_id)
        .then((user: User) => {
          if (user === undefined) {
            reject({ status: 404, userId: params.user_id })
          } else {
            resolve(user)
          }
        })
    })
  }

  afterModel(user: User, _transition: Transition<any>) {
    if (user?.attributes.onboardingInProgress) {
      const step = user?.attributes.lastOnboardingStep
      console.log("user.show onboarding redirect", step)
      this.transitionTo("user.onboarding", { queryParams: { step } })
    }
  }

  @action
  error(error: any, _transition: Transition) {
    if (error.status === 404) {
      console.log(`User was not found with ID "${error.userId}"`)
      this.replaceWith("not-found", "user-not-found")
      return undefined
    } else {
      // Let the route above this handle the error.
      return true
    }
  }
}
